import { render } from "./ItemDocsIconField.vue?vue&type=template&id=a5f04600"
import script from "./ItemDocsIconField.vue?vue&type=script&lang=js"
export * from "./ItemDocsIconField.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__